import { SegmentPartnerRevenueMethod } from '@openx/types/gqlTypes';
import { PartnerType } from './partnerFeeRows';

type PartnerTypeLabels = {
  caption: string;
  feeSummaryTitle: Record<SegmentPartnerRevenueMethod, string>;
  dataTestPrefix: string;
};

export const PARTNER_TYPE_LABELS: Record<PartnerType, PartnerTypeLabels> = {
  [PartnerType.AUDIENCE]: {
    caption: 'Partner Type: ID-based Audience',
    feeSummaryTitle: {
      [SegmentPartnerRevenueMethod.Cpm]: 'ID-based Audience Partner Fee - Fixed CPM:',
      [SegmentPartnerRevenueMethod.PoM]: 'ID-based Audience Partner Fee - Fixed Percentage of Media:',
    },
    dataTestPrefix: 'pricing-item',
  },
  [PartnerType.CONTEXTUAL]: {
    caption: 'Partner Type: Contextual',
    feeSummaryTitle: {
      [SegmentPartnerRevenueMethod.Cpm]: 'Contextual Partner Fee - Fixed CPM:',
      [SegmentPartnerRevenueMethod.PoM]: 'Contextual Partner Fee - Fixed Percentage of Media:',
    },
    dataTestPrefix: 'pricing-item-contextual',
  },
};

export const getPlatformFeeLabel = (pricingType: SegmentPartnerRevenueMethod): string => {
  const isCpm = pricingType === SegmentPartnerRevenueMethod.Cpm;

  return isCpm ? 'OpenX Platform Fee - CPM' : 'OpenX Platform Fee - Percentage of Media';
};
